import { Chip } from "@progress/kendo-react-buttons";
import "./statuschip.css";
import { useGetTachesAutomatiseesQuery } from "../../redux/api/cache";
import { Fragment } from "react";

interface StatusChipProps {
    statuts: string;
}

export default function StatusChip(props: StatusChipProps) {
    const { data: tachesAutomatisees = [], isLoading: isTachesAutomatiseesLoading, isFetching: isTachesAutomatiseesFetching } = useGetTachesAutomatiseesQuery();

    let statuts = props.statuts;
    if (!statuts)
        return <></>;

    let chips = statuts.split(",").map((e, i) => {
        if (e && tachesAutomatisees.find(t => t.code === e)) {
            return <Chip text={tachesAutomatisees.find(t => t.code === e)!.descriptionCourte} disabled={true} rounded="large" size="small" className="status-chip" key={i}></Chip>
        }
        return <Fragment key={i}></Fragment>;
    })

    return <>
        {!isTachesAutomatiseesFetching && !isTachesAutomatiseesLoading && (<div className="k-flex-wrap k-d-flex k-gap-1" style={{ justifySelf: 'end' }}>
            {chips}
        </div>)}
    </>;
};